import { cloneElement } from 'react';
import { getColorValue } from '@shinetools/sunshine';
import { CartesianGrid } from 'recharts';

const lineBaseStyle = {
  stroke: getColorValue('grey.300'),
  strokeDasharray: '0 4 4 0',
  strokeWidth: 0.5,
};

// Custom CartesianGrid
class CartesianGridNoDashHorizontal extends CartesianGrid {
  renderHorizontal(horizontalPoints: number[]): JSX.Element {
    const element = super.renderHorizontal(horizontalPoints);
    const lines = element.props.children.map(
      (el: JSX.Element, index: number) => {
        // Do not display first and last horizontal lines
        if (index === 0 || index === element.props.children.length - 1) {
          return cloneElement(el, { strokeWidth: 0 });
        }
        return cloneElement(el, { ...lineBaseStyle, strokeDasharray: '0' });
      },
    );
    return cloneElement(element, [], lines);
  }
  renderVertical(horizontalPoints: number[]): JSX.Element {
    const element = super.renderVertical(horizontalPoints);
    const lines = element.props.children.map(
      (el: JSX.Element, index: number) => {
        // Do not display first and last vertical lines
        if (
          index === element.props.children.length - 1 ||
          index === element.props.children.length - 2
        ) {
          return cloneElement(el, { strokeWidth: 0 });
        }
        return cloneElement(el, { ...lineBaseStyle });
      },
    );
    return cloneElement(element, [], lines);
  }
}

export default CartesianGridNoDashHorizontal;
